import { AppState, Auth0Provider as Provider } from "@auth0/auth0-react";
import { ReactNode, useMemo, type JSX } from "react";
import { useNavigate } from "react-router";
import { getConfig } from "config";

const Auth0Provider = ({ children }: { children: ReactNode }): JSX.Element => {
  const navigate = useNavigate();
  const config = useMemo(() => getConfig(), []);

  const onRedirectCallback = (appState?: AppState): void => {
    const returnTo = appState?.returnTo;
    void navigate(
      returnTo != null && returnTo !== "" ? returnTo : window.location.pathname,
    );
  };
  return (
    <Provider
      domain={config.auth0.domain}
      clientId={config.auth0.clientId}
      authorizationParams={{
        redirect_uri: config.app.url,
        audience: config.api.audience,
      }}
      cacheLocation={config.auth0.cacheLocation}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
    >
      {children}
    </Provider>
  );
};
export default Auth0Provider;
